export class FunIdAuthLogger {
    constructor() {
        this.storageKey = 'funid_debug';
        this.debugEnabled = Boolean(localStorage.getItem(this.storageKey));
    }
    log(...value) {
        if (!this.debugEnabled) {
            return;
        }
        const css = 'color: #6419E9';
        console.log('%c[FunId Auth]', css, ...value);
    }
}
//# sourceMappingURL=funid-auth-logger.js.map